<template>
  <div class="legal-links">
    <a
      v-if="accessibilityLink.showAccessibilityLink === true"
      :key="accessibilityLink.accessibilityActivate"
      :onclick="accessibilityLink.accessibilityOnclick"
      :href="accessibilityLink.accessibilityHref"
      :class="accessibilityLink.accessibilityStyle"
    >
      {{ accessibilityLink.accessibilityActivate }}
    </a>
    <a v-for="link in reducedLegalLinks" :key="link.name" :href="link.href">
      {{ link.name }}
    </a>
  </div>
</template>

<script>
export default {
  name: "NsLegalLinks",
  props: {
    links: {
      type: Array,
      default: function() {
        return [];
      }
    },
    accessibilityLink: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hideLegalLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // limit links to 3; limit sum of all link.names to 45 characters
    reducedLegalLinks() {
      if (this.hideLegalLinks || this.links.length <= 0) {
        return [];
      } else {
        const limitLinks =
          this.accessibilityLink.showAccessibilityLink === true ? 2 : 3;
        return this.links
          .filter(link => link.name)
          .slice(0, limitLinks)
          .map((link, index, slicedArray) => ({
            ...link,
            name: link.name.slice(0, Math.round(45 / slicedArray.length))
          }));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@nuskin/ns-core-styles/src/scss/global.mixins";
@import "~@nuskin/ns-core-styles/src/scss/globalVariables";

.legal-links {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 -15px;
}

.legal-links a {
  @include p-small-bold();
  margin: 0 15px;
  padding: 0;
  color: var(--color-interactive-8);
  font-weight: var(--font-weight-normal);
  line-height: normal;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  white-space: nowrap;

  &:hover {
    border-bottom: 1px solid currentColor;
  }
}

@media (max-width: 1023px) {
  .legal-links {
    flex-direction: column;
    align-items: unset;
    margin: 0;

    a {
      margin: 0;
      padding: 9px 15px 9px 29px;
      color: var(--color-interactive-7);
      text-decoration: none !important;
      border-bottom: none;
      line-height: normal;
      font-size: 18px;
      font-weight: normal;
      letter-spacing: 0.8px;

      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
